import { ContextMenuSelect, DataGrid } from '@turnpike/portal-data-grid';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useDeleteNotificationMutation, useNotificationsInfiniteQuery } from '../api';

import { useTableLayoutColumns } from './TableLayout.columns';
import Styles from './TableLayout.module.scss';

import type { NotificationModel } from '../model/types/notification.model';

import { useAppSelector } from '@/app/hooks/useAppSelector';
import { EditIcon, DeleteIcon, NotificationIcon } from '@/components/Elements/Icons';
import { ConfirmDeleteMessage } from '@/components/Modals/ConfirmDeleteMessage';
import { ConfirmDeleteModal } from '@/components/Modals/ConfirmDeleteModal';
import { useOrganizationsDictionary } from '@/features/Shared/hooks/useOrganizations';
import { useUsersDictionary } from '@/features/Shared/users';

export const TableLayout = () => {
	const [deleteNotification, { isLoading: isDeleting }] = useDeleteNotificationMutation();
	const [deleteItem, setDeleteItem] = useState<NotificationModel | null>(null);
	const [searchParams] = useSearchParams();
	const search = searchParams.get('filter') ?? '';
	const status = searchParams.get('status') ?? 'sent';
	const filter = useAppSelector((state) => state.filter);

	const { data: users } = useUsersDictionary({
		pageSize: 1000,
		organizationIds: filter.organizationIds,
	});

	const { currentData, isLoading, isFetching, fetchNextPage } = useNotificationsInfiniteQuery({
		...filter,
		title: search,
		onlyScheduled: status === 'scheduled',
	});
	const isLoadingData = isLoading || (!currentData && isFetching);

	const organizations = useOrganizationsDictionary();
	const items = currentData?.pages?.flatMap((page) => page.items) ?? [];
	const { columns, handleDetailsRow } = useTableLayoutColumns({ users, organizations });

	return (
		<div className={Styles.container}>
			<div className={Styles.gridContainer}>
				<DataGrid
					isLoading={isLoadingData}
					data={items}
					columns={columns}
					renderExpandedRow={handleDetailsRow}
					onEndReached={fetchNextPage}
					renderActions={(row) => {
						return (
							<ContextMenuSelect>
								<ContextMenuSelect.Option
									title="Edit"
									icon={<EditIcon />}
									onClick={() => console.log('edit')}
								/>
								<ContextMenuSelect.Option
									title="Delete"
									icon={<DeleteIcon />}
									onClick={() => setDeleteItem(row)}
								/>
							</ContextMenuSelect>
						);
					}}
				/>
				{deleteItem && (
					<ConfirmDeleteModal
						title="Do you want to delete this action?"
						isLoading={isDeleting}
						onCloseRequest={() => setDeleteItem(null)}
						onConfirm={async () => {
							await deleteNotification(deleteItem);
							setDeleteItem(null);
						}}
					>
						<ConfirmDeleteMessage
							iconBackground="rgb(26, 77, 229)"
							icon={
								<NotificationIcon
									stroke="red"
									style={{
										stroke: 'red',
									}}
								/>
							}
							message={deleteItem.title}
						/>
					</ConfirmDeleteModal>
				)}
			</div>
		</div>
	);
};
